module.exports = __webpack_public_path__ + "img/EgyptTechPriestRange1_ua.ea2a59c6.webp";